<div class="mb-27 mct-flex mct-row mct-justify-between mct-items-start">
  <div>
    <h2>{{ 'ecommerce.ecommerce-list.title' | translate | titlecase }}</h2>
    <a (click)="navigateToEcomSpa()">{{ 'ecommerce.ecommerce-list.view-store' | translate | titlecase }}</a>
  </div>
  <div>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="addNewEcomItem()">
      {{ 'ecommerce.ecommerce-list.create-new-item' | translate | uppercase }}
    </button>
  </div>
</div>

<div class="atlas-table atlas-container">
  <div class="mv-27">
    <p-checkbox name="showInactive" [(ngModel)]="searchParams.Inactive" [binary]="true" inputId="showInactive" (onChange)="search()">
    </p-checkbox>
    <label for="showInactive">
      {{ 'ecommerce.ecommerce-list.show-inactive-items' | translate | titlecase }}
    </label>
  </div>
  <p-table [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [lazy]="true"
    [totalRecords]="searchResult?.TotalCount"
    (onLazyLoad)="lazyLoad($event)"
    [lazyLoadOnInit]="false"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Title">
          {{ 'ecommerce.ecommerce-list.item-name' | translate | ucfirst }}
          <p-sortIcon field="Title"></p-sortIcon>
        </th>
        <th pSortableColumn="Price">
          {{ 'ecommerce.ecommerce-list.price' | translate | ucfirst }}
          <p-sortIcon field="Price"></p-sortIcon>
        </th>
        <th pSortableColumn="MemberPrice">
          {{ 'ecommerce.ecommerce-list.member-price' | translate | ucfirst }}
          <p-sortIcon field="MemberPrice"></p-sortIcon>
        </th>
        <th pSortableColumn="ItemNum">
          {{ 'ecommerce.ecommerce-list.revenue-item' | translate | ucfirst }}
          <p-sortIcon field="ItemNum"></p-sortIcon>
        </th>
        <th pSortableColumn="ItemTypeId">
          {{ 'ecommerce.ecommerce-list.item-type' | translate | ucfirst }}
          <p-sortIcon field="ItemTypeId"></p-sortIcon>
        </th>
        <th pSortableColumn="ItemId">
          {{ 'ecommerce.ecommerce-list.item-id' | translate | ucfirst }}
          <p-sortIcon field="ItemId"></p-sortIcon>
        </th>
        <th pSortableColumn="Inactive">
          {{ 'ecommerce.ecommerce-list.inactive' | translate | ucfirst }}
          <p-sortIcon field="Inactive"></p-sortIcon>
        </th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
      <tr>
        <th>
          <input
            pInputText
            type="text"
            placeholder="{{ 'ecommerce.ecommerce-list.item-name' | translate }}"
            styleClass="p-column-filter"
            [(ngModel)]="searchParams.Title"
            (input)="search()"
          />
        </th>
        <th style="text-align: center">
          <p-select
            [options]="operatorOptions"
            placeholder="{{ 'common.filter' | translate | titlecase }}"
            styleClass="p-column-filter"
            [(ngModel)]="searchParams.PriceOperator"
            (onChange)="searchHandler()"
            showClear
            appendTo="body"
          ></p-select>
          <input
            pInputText
            type="text"
            placeholder="{{ 'ecommerce.ecommerce-list.price' | translate }}"
            styleClass="p-column-filter"
            style="max-width: 100px; margin-left: 7px"
            [(ngModel)]="searchParams.Price"
            (input)="searchHandler()"
          />
        </th>
        <th style="text-align: center">
          <p-select
            [options]="operatorOptions"
            placeholder="{{ 'common.filter' | translate | titlecase }}"
            styleClass="p-column-filter"
            [(ngModel)]="searchParams.MemberPriceOperator"
            (onChange)="search()"
            showClear
            appendTo="body"
          ></p-select>
          <input
            pInputText
            type="text"
            placeholder="{{ 'ecommerce.ecommerce-list.member-price' | translate }}"
            styleClass="p-column-filter"
            style="max-width: 100px; margin-left: 7px"
            [(ngModel)]="searchParams.MemberPrice"
            (input)="search()"
          />
        </th>
        <th style="text-align: center">
          <p-select
            [options]="revenueItemOpts"
            placeholder="{{ 'common.filter' | translate | titlecase }}"
            styleClass="p-column-filter"
            [(ngModel)]="searchParams.ItemNum"
            (onChange)="search()"
            showClear
            appendTo="body"
          ></p-select>
        </th>
        <th style="text-align: center">
          <p-select
            [options]="ecomItemTypeOptions"
            placeholder="{{ 'common.filter' | translate | titlecase }}"
            styleClass="p-column-filter"
            [(ngModel)]="searchParams.ItemTypeId"
            (onChange)="search()"
            showClear
            appendTo="body"
          ></p-select>
        </th>
        <th>
          <input
            pInputText
            type="text"
            placeholder="{{ 'ecommerce.ecommerce-list.item-id' | translate }}"
            styleClass="p-column-filter"
            (input)="itemIdSearch($event.target.value)"
          />
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-ecomItem>
      <tr>
        <td>
          {{ ecomItem.Title }}
        </td>
        <td>
          {{ ecomItem.Price | translate | atlasCurrency }}
        </td>
        <td>
          {{ ecomItem.MemberPrice | translate | atlasCurrency }}
        </td>
        <td>
          {{ ecomItem.RevenueItem }}
        </td>
        <td>
          {{ ecomItem.ItemType }}
        </td>
        <td>
          {{ ecomItem.ItemId }}
        </td>
        <td>
          <p-checkbox
            name="inactive-item{{ i }}"
            [(ngModel)]="ecomItem.Inactive"
            [binary]="true"
            (onChange)="toggleInactive(ecomItem)"
          ></p-checkbox>
        </td>
        <td>
          <action-button
            icon="pi pi-chevron-down"
            [label]="'common.actions' | translate | uppercase"
            [items]="actionItemsForEcomItems(ecomItem.ItemId)"
          >
          </action-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
  <wl-page-size-dropdown
    [(pageSize)]="searchParams.PageSize"
    [pageSizes]="[20, 100, 0]"
    (pageSizeChange)="pageSizeChanged()"
  ></wl-page-size-dropdown>
</div>

<wl-ecom-item-settings-dialog
  #ecomItemEditDialogue
  [(show)]="showEdit"
  [(ecommerceItemId)]="ecomItemEditId"
  (itemSaved)="search()"
></wl-ecom-item-settings-dialog>

<p-confirmDialog
  #cd
  key="deleteEcomItemCD"
  header="{{ 'ecommerce.ecommerce-list.confirm-delete-header' | translate | titlecase }}"
  icon="pi pi-exclamation-triangle"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog #cd1 key="copyEcomItemCD" header="{{ 'common.confirmation' | translate | titlecase }}" icon="pi pi-exclamation-triangle">
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd1.reject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="cd1.accept()">
      {{ 'common.copy' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
